export const styles = theme => ({
    formControl: {
        // margin: theme.spacing(1),
        width: '100%',
    },
    chips: {
        display: 'flex',
        margin: -theme.spacing(0.5)
    },
    chip: {
        margin: theme.spacing(0.5),
    },
})